import React, {useEffect, useState} from "react";
import {
    addNewRowToTable,
    convertUniversalDateTimeToPersianDateTime, DialogSize,
    RaikoBaseCardContainer,
    RaikoBaseContainer, RaikoBreadcrumb, raikoBreadCrumbItemGenerator,
    RaikoCustomSelect,
    raikoCustomSelectItemGenerator, RaikoCustomSimpleActiveDeActiveChip, RaikoCustomTable, RaikoDefaultDialogPage,
    RaikoGridOneColumn,
    RaikoTableSearchContainer,
    RaikoTableTitleContainer, showServerErrorMessage
} from "@moeindal/base-raiko-panel-components";
import {RouteHelper} from "../../route/RouteHelper";
import {Helmet} from "react-helmet";
import {useDebounce} from "@uidotdev/usehooks";
import {useNavigate} from "react-router-dom";
import {css} from "@emotion/css";
import {TourismService} from "../../serverService/tourism/TourismService";
import TourismAddNew from "./TourismAddNew";

export default function TourismList() {

    const size = 20;
    let page = 0

    const navigate = useNavigate()

    const service = new TourismService();

    const [placeItems, setPlaceItems] = useState([])

    const [loading, setLoading] = useState(false)
    const [pageCount, setPageCount] = useState(0)
    const [totalItems, setTotalItems] = useState(0)

    const [titleFilter, setTitleFilter] = useState("")
    const [statusFilter, setStatusFilter] = useState("all")

    const _titleFilter = useDebounce(titleFilter, 500);
    const _statusFilter = useDebounce(statusFilter, 500);


    useEffect(() => {
        if (typeof service !== "undefined") {
            getDataFromServer()
        }
    }, [_titleFilter, _statusFilter]);

    function prepareItem(number, id, title, address, hours, createdAt, createdBy, phoneNumber, published) {
        return {
            number,
            id,
            title,
            address,
            hours,
            createdAt: convertUniversalDateTimeToPersianDateTime(createdAt),
            createdBy,
            phoneNumber,
            published: <RaikoCustomSimpleActiveDeActiveChip
                state={published}
                activeStateTitle={"منتشر شده"}
                deActiveStateTitle={"پیش نویس"}
            />
        }
    }

    function getDataFromServer() {
        setLoading(true)
        service.getTourismPlaceList(
            page,
            size,
            _titleFilter,
            _statusFilter
        ).then((response) => {
            setTotalItems(response.numberOfItems)
            setPageCount(response.totalPage)

            setPlaceItems([])
            response.data.map((item, index) => {
                setPlaceItems(prev => [
                    ...prev,
                    prepareItem(
                        (page * size) + index + 1,
                        item.id,
                        item.metaData ? item.metaData.title : "-",
                        item.metaData && item.metaData.address ? item.metaData.address.slice(0, 20) + " ..." : "-",
                        item.metaData && item.metaData.hours && item.metaData.hours.length > 0 ? item.metaData.hours : "-",
                        item.createdAt,
                        item.createdBy,
                        item.phoneNumber ? item.phoneNumber : "-",
                        item.published
                    )
                ])
            })

        }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(() => {
            setLoading(false)
        })
    }

    function handlePaginationChange(newPage) {
        page = newPage;
        getDataFromServer()
    }

    function handleShowDetail(placeId) {
        let _title = ""
        placeItems.map((item) => {
            if (item.id === placeId)
                _title = item.title
        })

        navigate(
            RouteHelper.TourismPlaceDetail.globalUrl.replace(":id", placeId),
            {state: {title: _title}, replace: false}
        )
    }

    const [openDialogState, setOpenDialogState] = useState(false)
    const handleOpenDialog = () => setOpenDialogState(true)
    const handleCloseDialog = () => setOpenDialogState(false)

    function addNewPlaceToTable(item) {
        let rowToTable = addNewRowToTable(
            prepareItem(
                1,
                item.id,
                item.metaData ? item.metaData.title : "-",
                "-",
                "-",
                item.createdAt,
                item.createdBy,
                "-",
                false
            ),
            placeItems
        );

        setPlaceItems(rowToTable);
    }

    return (
        <>
            <Helmet>
                <title>{RouteHelper.TourismPlaceList.name}</title>
            </Helmet>
            <RaikoDefaultDialogPage
                onClose={handleCloseDialog}
                open={openDialogState}
                dialogSize={DialogSize.WRAP_CONTENT}
                hasCloseButton={false}
            >
                <TourismAddNew
                    handleCloseDialog={handleCloseDialog}
                    handleAddNewPlace={addNewPlaceToTable}

                />
            </RaikoDefaultDialogPage>
            <RaikoBaseContainer>
                <RaikoGridOneColumn className={css`gap: 1.5rem`}>
                    <RaikoBreadcrumb
                        breadCrumbItems={[
                            raikoBreadCrumbItemGenerator(
                                RouteHelper.Tourism.name,
                                ""
                            ),
                            raikoBreadCrumbItemGenerator(
                                RouteHelper.TourismPlaceList.name,
                                ""
                            ),
                        ]}/>
                    <RaikoBaseCardContainer>
                        <RaikoGridOneColumn>

                            <RaikoTableTitleContainer
                                title={RouteHelper.TourismPlaceList.name}
                                amount={totalItems}
                                hasCreateNewItem
                                createNewItemTitle={"افزودن"}
                                handleCreateNewItem={handleOpenDialog}
                            />
                            <RaikoTableSearchContainer
                                value={titleFilter}
                                setValue={setTitleFilter}
                                labelText={"عنوان"}
                                hasFilter
                                filterStatus={statusFilter && statusFilter !== "all"}
                                handleDeleteAllFilters={_ => {
                                    setStatusFilter("")
                                }}
                            >
                                <RaikoCustomSelect
                                    labelText={"وضعیت انتشار"}
                                    value={statusFilter}
                                    setValue={setStatusFilter}
                                    items={[
                                        raikoCustomSelectItemGenerator("all", "همه"),
                                        raikoCustomSelectItemGenerator("true", "منتشر شده"),
                                        raikoCustomSelectItemGenerator("false", "پیش نویس"),
                                    ]}

                                />
                            </RaikoTableSearchContainer>
                            <RaikoCustomTable
                                header={header}
                                data={placeItems}
                                isLoading={loading}
                                pageCount={pageCount}
                                handlePaginationChange={handlePaginationChange}
                                rowClicked={handleShowDetail}
                            />
                        </RaikoGridOneColumn>
                    </RaikoBaseCardContainer>
                </RaikoGridOneColumn>
            </RaikoBaseContainer>
        </>
    )
}


const header = [
    {
        id: "number",
        label: "#"
    },
    {
        id: "title",
        label: "عنوان"
    },
    {
        id: "address",
        label: "نشانی"
    },
    {
        id: "hours",
        label: "ساعت کاری"
    },

    {
        id: "phoneNumber",
        label: "شماره همراه"
    },
    {
        id: "createdBy",
        label: "سازنده"
    },
    {
        id: "createdAt",
        label: "تاریخ ساخت"
    },
    {
        id: "published",
        label: "وضعیت"
    },
]